export interface PaymentToastProps {
    message: string;
    type?: TOAST_TYPE;
}

export enum TOAST_TYPE {
    ERROR = "ERROR",
    INFO = "INFO",
    INFO_FILLED = "INFO_FILLED",
}
